import QuoteProposalSidebar from "../QuoteProposalSidebar";
import QuoteProposalHeader from "../QuoteProposalHeader";
import { useState, useRef, useEffect } from "react";
import { FileUpload } from "primereact/fileupload";
import { TabView, TabPanel } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
import { Image } from "primereact/image";
import { Toast } from "primereact/toast";
import SupportLoader from "../../common/SupportLoader";
import CommonValues from "../../common/utils";
import { useNavigate } from "react-router-dom";

export default function ProposalSettings() {
  const toast: any = useRef("");
  const [companyId, setCompanyId] = useState(0);
  const [companyName, setCompanyName] = useState("");
  const [website, setWebsite] = useState("");
  const [aboutUs, setAboutUs] = useState("");
  const [companyOverview, setCompanyOverview] = useState("");
  const [vision, setVision] = useState("");
  const [mission, setMission] = useState("");
  const [address, setAddress] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [defaultQuoteType, setDefaultQuoteType] = useState("auto");
  const [autoSaveDrafts, setAutoSaveDrafts] = useState(false);
  const [displayCurrency, setDisplayCurrency] = useState("auto");
  const [emailNotification, setEmailNotification] = useState(false);
  const [primaryColor, setPrimaryColor] = useState("");
  const [secondaryColor, setSecondaryColor] = useState("");
  const fileUploadRef = useRef<FileUpload>(null);
  const [loading, setLoading] = useState(false);
  const [companyNameError, setCompanyNameError] = useState("");
  const [websiteError, setWebsiteError] = useState("");
  const [aboutUsError, setAboutUsError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [spinnerloading, setSpinnerLoading] = useState(false);
  const [uploadLogoLoading, setUploadLogoLoading] = useState(false);
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([{ name: "", role: "", profilePhoto: "" }]);
  const navigate = useNavigate();

  useEffect(() => {
    getAllSettings();
  }, []);

  const getAllSettings = () => {
    const token = CommonValues.GetToken();
    setSpinnerLoading(true);
    var config = {
      method: "get",

      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/getcompanyhistory`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        const data = response.data;
        setCompanyId(data.companyId || 0);
        setCompanyName(data.name || "");
        setWebsite(data.website || "");
        setAboutUs(data.aboutUs || "");
        setAddress(data.address || "");
        setLogoUrl(data.logoUrl || "");
        setDefaultQuoteType(data.defaultQuoteType || "auto");
        setAutoSaveDrafts(data.autoSaveDrafts || false);
        setDisplayCurrency(data.displayCurrency || "auto");
        setEmailNotification(data.emailNotification || false);
        setPrimaryColor(data.primaryColour?.trim() ? data.primaryColour : "#243353");
        setSecondaryColor(data.secondaryColour?.trim() ? data.secondaryColour : "#E0677D");
        setVision(data.vision);
        setMission(data.mission);
        setCompanyOverview(data.overview);
        setTeamMembers(typeof data.teamMembers === "string" ? JSON.parse(data.teamMembers) : data.teamMembers || []);
        setSpinnerLoading(false);
      })
      .catch((error: any) => {
        setSpinnerLoading(false);

        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Unknown error while loading the company details",
              life: 3000,
            });
          }
        }
      });
  };
  const checkValidation = () => {
    let returnValue = true;
    setCompanyNameError("");
    setWebsiteError("");
    setAboutUsError("");
    setAddressError("");
    if (companyName == null || companyName == "") {
      setCompanyNameError("Please enter company name");
      returnValue = false;
    }
    if (website == null || website == "") {
      setWebsiteError("Please enter website");
      returnValue = false;
    }
    if (aboutUs == null || aboutUs == "") {
      setAboutUsError("Please enter about us");
      returnValue = false;
    }

    if (address == null || address == "") {
      setAddressError("Please enter address");
      returnValue = false;
    }
    return returnValue;
  };
  const handleSaveSettings = () => {
    if (checkValidation()) {
      const validMembers = teamMembers.filter(
        (member) => member.name.trim() !== "" || member.role.trim() !== "" || member.profilePhoto.trim() !== ""
      );
      const token = CommonValues.GetToken();
      var data = JSON.stringify({
        companyId: companyId,
        name: companyName,
        Website: website,
        AboutUs: aboutUs,
        Address: address,
        LogoUrl: logoUrl,
        DefaultQuoteType: defaultQuoteType,
        AutoSaveDrafts: autoSaveDrafts,
        DisplayCurrency: displayCurrency,
        EmailNotification: emailNotification,
        primaryColour: primaryColor,
        secondaryColour: secondaryColor,
        Overview: companyOverview,
        Vision: vision,
        Mission: mission,
        teamMembers: JSON.stringify(validMembers),
      });

      var config = {
        method: "post",
        url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/companyhistory`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      setLoading(true);

      axios(config)
        .then((response) => {
          setLoading(false);
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Settings saved successfully.",
            life: 3000,
          });
        })
        .catch((error) => {
          setLoading(false);
          if (error.response !== null) {
            if (error.response.status === 401) {
              CommonValues.Logout(navigate);
            } else {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Failed to save settings",
                life: 3000,
              });
            }
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Failed to save settings",
              life: 3000,
            });
          }
        });
    }
  };
  const handleReset = () => {
    if (fileUploadRef.current) {
      fileUploadRef.current.clear();
    }
    setLogoUrl("");
  };

  const onFileUpload = (e: any) => {
    setUploadLogoLoading(true);
    let data = new FormData();
    data.append("file", e.files[0]);

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/uploadlogo`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        setLogoUrl(response.data.fileURL);
        setUploadLogoLoading(false);
      })
      .catch((error) => {
        setUploadLogoLoading(false);
      });
  };
  type TeamMember = {
    name: string;
    role: string;
    profilePhoto: string;
  };

  const handleInputChange = (index: number, field: keyof TeamMember, value: string) => {
    const updated = [...teamMembers];
    updated[index][field] = value;
    setTeamMembers(updated);
  };

  const handleAddMember = () => {
    setTeamMembers([...teamMembers, { name: "", role: "", profilePhoto: "" }]);
  };

  const handleDeleteMember = (index: number) => {
    const updated = teamMembers.filter((_, i) => i !== index);
    setTeamMembers(updated);
  };

  const handleProfilePhotoUpload = async (file: File | undefined, index: number) => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      const token = CommonValues.GetToken();
      const response = await axios.post(`${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/upload/TeamProfilePhoto`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const fileURL = response.data?.fileURL;
      if (fileURL) {
        setTeamMembers((prevMembers) => {
          const updatedMembers = [...prevMembers];
          updatedMembers[index] = {
            ...updatedMembers[index],
            profilePhoto: fileURL,
          };
          return updatedMembers;
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Upload Error",
        detail: "Failed to upload profile picture.",
        life: 3000,
      });
    }
  };

  return (
    <div className="d-flex">
      <Toast ref={toast} />
      <QuoteProposalSidebar pagename="proposal-settings" />
      <div className="flex-grow-1 d-flex flex-column overflow-hidden">
        <QuoteProposalHeader />
        <main className="flex-grow-1 overflow-auto p-1 bg-light quote-proposal-main-content">
          <div className="card-body pt-4 px-4">
            <h2 className="fs-4 fw-bold">Settings</h2>
            <div className="mb-3">
              <p className="text-muted small">Manage your account and preferences</p>
              {spinnerloading ? (
                <div className="d-flex justify-content-center align-items-center">
                  <SupportLoader />{" "}
                </div>
              ) : (
                <TabView className="mb-4 qp-setting-tab">
                  <TabPanel header={<span className="">Company</span>}>
                    <div className="card p-4 mb-4">
                      <h3 style={{ fontSize: "21px", fontWeight: "bold" }}>About Your Company</h3>
                      <p className="text-muted small mb-4" style={{ fontSize: "13px" }}>
                        Add information about your business that will appear on quotes.
                      </p>
                      <div className="row">
                        <div className="mb-4 col-6">
                          <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                            Company Name
                          </label>
                          <div className="d-flex flex-column gap-1">
                            <InputText
                              id="companyName"
                              className={`flex-fill ${companyNameError ? "p-invalid" : ""}`}
                              value={companyName}
                              style={{ fontSize: "13px" }}
                              onChange={(e) => {
                                setCompanyName(e.target.value);
                                setCompanyNameError("");
                              }}
                              placeholder="Company Name"
                            />
                            {companyNameError && <small className="p-error">{companyNameError}</small>}
                          </div>
                          <small className="text-muted mt-2 d-block"></small>
                        </div>

                        <div className="p-field p-grid col-6">
                          <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                            Website
                          </label>
                          <div className="p-col-12 p-md-10">
                            <div className="p-inputgroup">
                              <span className="p-inputgroup-addon">
                                <i className="pi pi-globe"></i>
                              </span>
                              <InputText
                                id="website"
                                className={`flex-fill ${websiteError ? "p-invalid" : ""}`}
                                value={website}
                                style={{ fontSize: "13px" }}
                                onChange={(e) => {
                                  setWebsite(e.target.value);
                                  setWebsiteError("");
                                }}
                                placeholder="Website"
                              />
                            </div>
                            {websiteError && <small className="p-error d-block mt-1">{websiteError}</small>}
                          </div>
                        </div>

                        <div className="mb-2 col-6">
                          <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                            Company Overview
                          </label>
                          <div className="d-flex flex-column gap-1">
                            <InputTextarea
                              className={`flex-fill`}
                              placeholder="Describe your company overview"
                              style={{ fontSize: "13px" }}
                              onChange={(e) => {
                                setCompanyOverview(e.target.value);
                              }}
                              rows={4}
                              cols={30}
                              value={companyOverview}
                            />
                          </div>
                        </div>

                        <div className="mb-2 col-6">
                          <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                            About Us
                          </label>
                          <div className="d-flex flex-column gap-1">
                            <InputTextarea
                              className={`flex-fill ${aboutUsError ? "p-invalid" : ""}`}
                              placeholder="Describe your company and services..."
                              style={{ fontSize: "13px" }}
                              onChange={(e) => {
                                setAboutUs(e.target.value);
                                setAboutUsError("");
                              }}
                              rows={4}
                              cols={30}
                              value={aboutUs}
                            />
                            {aboutUsError && <small className="p-error">{aboutUsError}</small>}
                          </div>
                          <small className="text-muted mt-2 d-block"></small>
                        </div>

                        <div className="mb-2 col-6">
                          <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                            Vision
                          </label>
                          <div className="d-flex flex-column gap-1">
                            <InputTextarea
                              className={`flex-fill`}
                              placeholder="Describe your company vision"
                              style={{ fontSize: "13px" }}
                              onChange={(e) => {
                                setVision(e.target.value);
                              }}
                              rows={4}
                              cols={30}
                              value={vision}
                            />
                          </div>
                        </div>

                        <div className="mb-2 col-6">
                          <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                            Mission
                          </label>
                          <div className="d-flex flex-column gap-1">
                            <InputTextarea
                              className={`flex-fill`}
                              placeholder="Describe your company mission"
                              style={{ fontSize: "13px" }}
                              onChange={(e) => {
                                setMission(e.target.value);
                              }}
                              rows={4}
                              cols={30}
                              value={mission}
                            />
                          </div>
                        </div>

                        <div className="mb-4">
                          <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                            Address
                          </label>
                          <div className="d-flex flex-column gap-1">
                            <InputText
                              id="address"
                              className={`flex-fill ${addressError ? "p-invalid" : ""}`}
                              value={address}
                              style={{ fontSize: "13px" }}
                              onChange={(e) => {
                                setAddress(e.target.value);
                                setAddressError("");
                              }}
                              placeholder="Address"
                            />
                            {addressError && <small className="p-error">{addressError}</small>}
                          </div>
                          <small className="text-muted mt-2 d-block"></small>
                        </div>
                      </div>
                    </div>

                    <div className="card p-4 mb-4">
                      <h3 style={{ fontSize: "21px", fontWeight: "bold" }}>Team Members</h3>
                      <p className="text-muted small mb-4" style={{ fontSize: "13px" }}>
                        Add team members that will appear on your materials
                      </p>

                      <div
                        className="team-grid"
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3, 1fr)",
                          gap: "24px",
                          padding: "0 24px",
                        }}
                      >
                        {teamMembers.map((member, index) => (
                          <div
                            key={index}
                            className="card"
                            style={{
                              minWidth: "200px",
                              boxSizing: "border-box",
                            }}
                          >
                            <div className="pt-8 px-3 d-flex justify-content-end">
                              <Button icon="pi pi-trash" className="p-button-text p-button-danger" onClick={() => handleDeleteMember(index)} />
                            </div>
                            <div className="mb-3 text-center">
                              <label htmlFor={`file-upload-${index}`} style={{ cursor: "pointer" }}>
                                {member.profilePhoto ? (
                                  <img
                                    src={member.profilePhoto}
                                    alt="Profile"
                                    style={{ width: "80px", height: "80px", borderRadius: "50%", objectFit: "cover" }}
                                  />
                                ) : (
                                  <div
                                    className="text-purple bg-purple"
                                    style={{
                                      width: "80px",
                                      height: "80px",
                                      borderRadius: "100%",
                                      margin: "0 auto",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontWeight: "bold",
                                      fontSize: "30px",
                                    }}
                                  >
                                    {member.name ? (
                                      member.name
                                        .split(" ")
                                        .map((word) => word[0])
                                        .slice(0, 2)
                                        .join("")
                                    ) : (
                                      <i className="pi pi-user-plus" style={{ fontSize: "28px" }} />
                                    )}
                                  </div>
                                )}
                              </label>
                              <input
                                id={`file-upload-${index}`}
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={(e) => handleProfilePhotoUpload(e.target.files?.[0], index)}
                              />
                            </div>

                            <div className="p-3">
                              <input
                                type="text"
                                className="form-control mb-2"
                                placeholder="Name"
                                style={{ fontSize: "13px" }}
                                value={member.name}
                                onChange={(e) => handleInputChange(index, "name", e.target.value)}
                              />
                              <input
                                type="text"
                                className="form-control mb-2"
                                style={{ fontSize: "13px" }}
                                placeholder="Role"
                                value={member.role}
                                onChange={(e) => handleInputChange(index, "role", e.target.value)}
                              />
                            </div>
                          </div>
                        ))}

                        {teamMembers.length < 3 && (
                          <div
                            className="card d-flex justify-content-center align-items-center"
                            style={{
                              minWidth: "200px",
                              height: "262px",
                              cursor: "pointer",
                              border: "1px dashed #ccc",
                              boxSizing: "border-box",
                            }}
                            onClick={handleAddMember}
                          >
                            <div className="text-center">
                              <i
                                className="pi pi-plus-circle mb-2 text-purple"
                                style={{
                                  fontSize: "24px",
                                }}
                              ></i>
                              <div
                                className="text-purple"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "15px",
                                }}
                              >
                                Add Team Member
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="pt-3 px-4 d-flex justify-content-end mb-2">
                      <Button onClick={handleSaveSettings} disabled={loading} className={`company-save-btn ${loading ? "loading" : ""}`}>
                        {loading ? <i className="pi pi-spin pi-spinner company-save-icon" /> : ""}
                        {loading ? " Saving..." : " Save Info"}
                      </Button>
                    </div>
                  </TabPanel>

                  <TabPanel header={<span> Appearance</span>}>
                    <div className="card p-4 mb-4">
                      <div>
                        <h3 style={{ fontSize: "21px", fontWeight: "bold" }}>Logo</h3>
                        <p className="text-muted small mb-4" style={{ fontSize: "13px" }}>
                          {" "}
                          Upload your company logo.
                        </p>
                      </div>
                      <div className="rounded-3 p-4 text-center" style={{ border: "2px dashed #e2e8f0" }}>
                        {uploadLogoLoading ? (
                          <ProgressSpinner style={{ width: "3rem", height: "3rem", color: "#0d6efd" }} strokeWidth="3" />
                        ) : (
                          <>
                            {logoUrl != null && logoUrl != "" ? (
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                <Image src={logoUrl} alt="Insurance Image" className="rounded " height="48px" />
                              </div>
                            ) : (
                              <>
                                <i className="pi pi-upload" style={{ fontSize: "2rem" }}></i>
                                <p className="text-muted small mt-2 mb-1">Upload your company logo.</p>
                                <div className="d-flex justify-content-center align-items-center gap-2">
                                  <FileUpload
                                    ref={fileUploadRef}
                                    className="mt-3 text-black "
                                    id="logo-upload"
                                    customUpload
                                    mode="basic"
                                    chooseLabel="Upload Logo"
                                    accept=".jpeg,.png,.webp"
                                    maxFileSize={10000000}
                                    onSelect={(e) => onFileUpload(e)}
                                    style={{
                                      borderRadius: "9px",
                                      border: "1px solid #ccc",
                                      padding: "0.1rem 0.1rem",
                                      backgroundColor: "transparent",
                                    }}
                                  />
                                </div>
                              </>
                            )}
                            <Button
                              className="mt-3 text-black "
                              onClick={handleReset}
                              style={{
                                borderRadius: "10px",
                                padding: "0.6rem 1.5rem",
                                backgroundColor: "transparent",
                              }}
                            >
                              Reset
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="card mb-4">
                      <div className="p-4 bg-white rounded shadow-sm w-100">
                        <h3 style={{ fontSize: "21px", fontWeight: "bold" }}>Brand Colors</h3>
                        <p className="text-muted small mb-4" style={{ fontSize: "13px" }}>
                          Choose your brand's colors
                        </p>

                        <div className="d-flex flex-wrap gap-4 mb-4">
                          <div className="flex-grow-1 min-w-260px">
                            <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                              Primary Color
                            </label>
                            <div className="d-flex align-items-center gap-3">
                              <div
                                className="rounded-circle"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  fontSize: "13px",
                                  backgroundColor: primaryColor,
                                }}
                              />
                              <input
                                type="color"
                                value={primaryColor}
                                style={{ fontSize: "13px" }}
                                onChange={(e) => setPrimaryColor(e.target.value)}
                                className="form-control form-control-color border"
                              />
                              <InputText
                                value={primaryColor}
                                style={{ fontSize: "13px" }}
                                onChange={(e) => setPrimaryColor(e.target.value)}
                                className="w-25"
                              />
                            </div>
                          </div>
                          <div className="flex-grow-1 min-w-260px">
                            <label className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                              Secondary Color
                            </label>
                            <div className="d-flex align-items-center gap-3">
                              <div
                                className="rounded-circle"
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  backgroundColor: secondaryColor,
                                }}
                              />
                              <input
                                type="color"
                                value={secondaryColor}
                                style={{ fontSize: "13px" }}
                                onChange={(e) => setSecondaryColor(e.target.value)}
                                className="form-control form-control-color border"
                              />
                              <InputText
                                value={secondaryColor}
                                style={{ fontSize: "13px" }}
                                onChange={(e) => setSecondaryColor(e.target.value)}
                                className="w-25"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="border rounded p-3 mb-5">
                          <p className="form-label mb-1" style={{ fontSize: "14px", fontWeight: "bold" }}>
                            Preview
                          </p>
                          <div className="d-flex gap-2 overflow-hidden rounded">
                            <div
                              className="flex-fill py-3 text-center text-white fw-bold"
                              style={{
                                backgroundColor: primaryColor,
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              Primary
                            </div>
                            <div
                              className="flex-fill py-3 text-center text-white fw-bold"
                              style={{
                                backgroundColor: secondaryColor,
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            >
                              Secondary
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <Button onClick={handleSaveSettings} disabled={loading} className={`company-save-btn ${loading ? "loading" : ""}`}>
                            {loading ? <i className="pi pi-spin pi-spinner company-save-icon" /> : ""}
                            {loading ? " Saving..." : " Save Colors"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  {/* <TabPanel header={<span>Preferences </span>}>
                    <div className="card p-4 mb-4">
                      <h3 style={{ fontSize: "21px", fontWeight: "bold" }}>
                        System Preferences
                      </h3>
                      <p
                        className="text-muted small mb-4"
                        style={{ fontSize: "13px" }}
                      >
                        Customize how the application works for you
                      </p>

                      <div className="d-flex flex-column gap-4">
                        <div className="d-flex justify-content-between border-bottom pb-4">
                          <div className="pe-4 flex-grow-1">
                            <label
                              className="form-label mb-1"
                              style={{ fontSize: "14px", fontWeight: "bold" }}
                            >
                              Default Quote Type
                            </label>
                            <p
                              className="text-muted small mb-4"
                              style={{ fontSize: "13px" }}
                            >
                              Set the default insurance type for new quotes
                            </p>
                          </div>
                          <div className="w-50 d-flex justify-content-end">
                            <Dropdown
                              value={defaultQuoteType}
                              style={{ fontSize: "13px", height: "50px" }}
                              options={[
                                {
                                  label: "Auto Insurance",
                                  value: "Auto Insurance",
                                },
                                {
                                  label: "Home Insurance",
                                  value: "Home Insurance",
                                },
                                {
                                  label: "Health Insurance",
                                  value: "Health Insurance",
                                },
                                {
                                  label: "Life Insurance",
                                  value: "Life Insurance",
                                },
                              ]}
                              className="w-50"
                              onChange={(e) => {
                                setDefaultQuoteType(e.value);
                                setDefaultQuoteTypeError(false);
                              }}
                              id="DefaultQuoteType"
                            />
                            {""}
                            {defaultQuoteTypeError && (
                              <small className="p-error">
                                Default Quote Type is required.
                              </small>
                            )}
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center border-bottom pb-4">
                          <div>
                            <label
                              className="form-label mb-1"
                              style={{ fontSize: "14px", fontWeight: "bold" }}
                            >
                              Auto-save Drafts
                            </label>
                            <p
                              className="text-muted small mb-4"
                              style={{ fontSize: "13px" }}
                            >
                              Automatically save quote drafts every 5 minutes
                            </p>
                          </div>
                          <InputSwitch
                            checked={autoSaveDrafts}
                            onChange={(e) => setAutoSaveDrafts(e.value)}
                          />
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <label
                              className="form-label mb-1"
                              style={{ fontSize: "14px", fontWeight: "bold" }}
                            >
                              Display Currency
                            </label>
                            <p
                              className="text-muted small mb-4"
                              style={{ fontSize: "13px" }}
                            >
                              Choose your preferred currency display
                            </p>
                          </div>
                          <div className="w-50 d-flex justify-content-end">
                            <Dropdown
                              value={displayCurrency}
                              style={{ fontSize: "13px" }}
                              options={[
                                { label: "USD($)", value: "USD" },
                                { label: "EUR(€)", value: "EUR" },
                                { label: "GBP(£)", value: "GBP" },
                                { label: "CAD(C$)", value: "CAD" },
                              ]}
                              className="w-50"
                              onChange={(e) => {
                                setDisplayCurrency(e.value);
                                setDisplayCurrencyError(false);
                              }}
                            />{" "}
                            {displayCurrencyError && (
                              <small className="p-error">
                                Currency is required.
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="pt-4 d-flex justify-content-end">
                        
                        <Button
                          onClick={handleSaveSettings}
                          disabled={loading}
                          className={`company-save-btn ${
                            loading ? "loading" : ""
                          }`}
                        >
                          {loading ? (
                            <i className="pi pi-spin pi-spinner company-save-icon" />
                          ) : (
                            ""
                          )}
                          {loading ? " Saving..." : " Save Preferences"}
                        </Button>
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel header={<span> Notifications</span>}>
                    <div className="card p-4 mb-4">
                      <h3 style={{ fontSize: "21px", fontWeight: "bold" }}>
                        Notification Settings
                      </h3>
                      <p
                        className="text-muted small mb-4"
                        style={{ fontSize: "13px" }}
                      >
                        Manage how you receive notifications
                      </p>
                      <div className="d-flex justify-content-between align-items-start mb-4">
                        <div className="pe-3">
                          <label
                            className="form-label mb-1"
                            style={{ fontSize: "14px", fontWeight: "bold" }}
                          >
                            Email Notification When Quote Is Opened
                          </label>
                          <p
                            className="text-muted small mb-4"
                            style={{ fontSize: "13px" }}
                          >
                            Receive an email when a client views your quote
                            proposal
                          </p>
                        </div>
                        <InputSwitch
                          checked={emailNotification}
                          onChange={(e) => setEmailNotification(e.value)}
                        />
                      </div>
                      <div className="pt-3 d-flex justify-content-end mb-2">
                        
                        <Button
                          onClick={handleSaveSettings}
                          disabled={loading}
                          className={`company-save-btn ${
                            loading ? "loading" : ""
                          }`}
                        >
                          {loading ? (
                            <i className="pi pi-spin pi-spinner company-save-icon" />
                          ) : (
                            ""
                          )}
                          {loading ? " Saving..." : " Save Preferences"}
                        </Button>
                      </div>
                    </div>
                  </TabPanel> */}
                </TabView>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
